/**
 * Queue preview must stream GET /document/file/:id through DocumentViewer.
 * Do not fetch GET /document/:id — that JSON payload is assignment-gated
 * and is why unassigned manual uploads showed "Something went wrong".
 */
export const getQueuePreviewViewerProps = ({
  documentId,
  url,
  fileName,
} = {}) => ({
  documentId: documentId || "",
  pdfUrl: url || "",
  fileName: fileName || "",
  imageList: [],
  currentIndex: 1,
});
